module.exports = __webpack_public_path__ + "static/media/c46b50c9-af8a-4310-aafc-030da9ff8d11.1c83f327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/c46b50c9-af8a-4310-aafc-030da9ff8d11.png
// module id = 1494
// module chunks = 0